var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dot-process"},[_c('tabs',{attrs:{"tabs":_vm.TABS.map(function (i) { return i.name; }),"index":_vm.tabIndex}}),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }